import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

import _ from 'lodash';

import { getMonths } from '../../utils/constCodeUtils';

const HeadquartersGoalSetting = ({ rows, onSave }) => {

    const [months, setMonths] = useState([]);
    const [edit, setEdit] = useState(false);

    const [editData, setEditData] = useState(null);

    useEffect(() => {
        const arrMonths = getMonths();
        setMonths(arrMonths);


    }, [])

    const handleEdit = (row) => {
        setEditData(row)
        setEdit(true);
    }


    const handleCancle = () => {
        setEdit(false);
        setEditData(null)
    }

    const handleChange = (event,month)=>{
         
        const clone = _.cloneDeep(editData);
        clone[month] = Number(event.target.value);
        setEditData(clone);
    }

    const handleSave = ()=>{
        setEditData(null);
        setEdit(false);
    }




    return (
        <TableContainer component={Paper}>
            <Table aria-label="headquarter year goal table">
                <TableHead>
                    <TableRow>
                        <TableCell>본부명</TableCell>
                        {months && months.map((month) => (
                            <TableCell key={month} align="right">{month} 월</TableCell>
                        ))}
                        <TableCell align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows && rows.map((row) => (
                        <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row?.dptNm}
                            </TableCell>
                            {months && months.map((month, index) => (
                                <React.Fragment>
                                    {
                                        edit && row.id === editData.id ? (
                                            <TableCell key={`${row.id}_${month}`}>
                                                <TextField
                                                  size="small"
                                                  type="number"
                                                    required
                                                    id={index}
                                                    label={`${month}월_목표`}
                                                    value={editData[month]}
                                                    onChange={(event)=>handleChange(event,month)}
                                                />
                                            </TableCell>
                                        ) : (
                                            <TableCell key={`${row.id}_${month}`} align="right">{row[month]}</TableCell>
                                        )
                                    }
                                </React.Fragment>
                            ))}
                            <TableCell align="center">
                                {edit && row.id === editData.id ? (
                                    <Box>
                                        <IconButton aria-label="save">
                                            <SaveIcon onClick={handleSave}/>
                                        </IconButton>
                                        <IconButton aria-label="cancel" onClick={handleCancle}>
                                            <CancelIcon />
                                        </IconButton>
                                    </Box>
                                ) : (
                                    <IconButton aria-label="edit" onClick={()=>handleEdit(row)}>
                                        <EditIcon />
                                    </IconButton>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default HeadquartersGoalSetting